// extracted by mini-css-extract-plugin
export default {"projPage":"ProjectsPage_projPage__Hq0lj","main":"ProjectsPage_main__M+nF4"};